'use strict';
var _ = require('underscore');
var convertHelper = require('../types/convertHelper');
var dataHelper = require('./dataHelper');
var appTypes = require('../types/appTypes');
var propConst = require('../constants/propConst');
var util = require('../helper/util');
var measureHelper = require('./measureHelper');
var versionHelper = require('./versionHelper');

exports.getPropertyValue = function (props, name) {
  var v;
  var stateProperties = props.stateProperties;
  var currentPName = 'current' + name.charAt(0).toUpperCase() + name.substring(1);
  if (stateProperties && stateProperties.hasOwnProperty(name)) {
    v = stateProperties[name];
  } else {
    if (props.hasOwnProperty(currentPName)) {
      v = props[currentPName];
    }
    if (_.isUndefined(v)) {
      v = props[name];
    }
  }
  return v;
};

exports.getStateProperty = function (props, name) {
  var v = undefined;
  if (props.stateProperties) {
    if (props.stateProperties.hasOwnProperty(name)) {
      v = props.stateProperties[name];
    }
  }
  return v;
};

exports.getOriginalProperty = function (props, name) {
  return props[name];
};

exports.getInt = function (props, name) {
  var v = this.getPropertyValue(props, name);
  if (_.isUndefined(v)) {
    return 0;
  }
  return parseInt(v, 10);
};

exports.getFloat = function (props, name) {
  var v = this.getPropertyValue(props, name);
  if (_.isUndefined(v)) {
    return 0;
  }
  return parseFloat(v);
};

/**
 * 获取组件的透明度
 * @param comp React.CreateElement的对象
 * @returns {*} float (0-1)
 */
exports.getOpacity = function (comp) {
  var props = comp.props;
  var state = comp.state;

  if (state) {
    if (state.stateProperties) {
      if (!_.isUndefined(state.stateProperties.opacity)) {
        return parseInt(state.stateProperties.opacity, 10) / 100;
      }
    }
  }
  if (!_.isUndefined(props.currentOpacity)) {
    return parseInt(props.currentOpacity, 10) / 100;
  }
  if (_.isUndefined(props.opacity)) {
    return 1;
  }
  return parseFloat(props.opacity);
};

/**
 * 获取组件的可见状态
 * @param comp React.CreateElement 的对象
 * @returns {*} bool
 */
exports.getVisible = function (comp) {
  var props = comp.props;
  var state = comp.state;
  if (state) {
    if (state.stateProperties) {
      if (!_.isUndefined(state.stateProperties.isShow)) {
        return state.stateProperties.isShow;
      }
    }
  }

  if (!_.isUndefined(props.currentVisible)) {
    return props.currentVisible;
  }

  if (_.isUndefined(props.isShow)) {
    return true;
  }
  return props.isShow;
};

exports.getTextColor = function (props) {
  var c = this.getPropertyValue(props, 'textColor');

  if (props.isAutoTextColor) {
    if (dataHelper.isLightColor(props.color)) {
      return '#000';
    } else {
      return '#fff';
    }
  }

  return c || '#000';
};

exports.getSelectedTextColor = function (props) {
  return this.getPropertyValue(props, propConst.SELECTED_TEXT_COLOR);
};

exports.getWidth = function (props) {
  if (_.isUndefined(props.currentW))
    return props.w;
  return props.currentW;
};

exports.getX = function (props) {
  return this.getPropertyValue(props, 'x');
};

exports.getY = function (props) {
  return this.getPropertyValue(props, 'y');
};

exports.getPoint = function (props) {
  return {
    x: this.getX(props),
    y: this.getY(props)
  };
};
exports.getHeight = function (props) {
  if (_.isUndefined(props.currentH))
    return props.h;
  return props.currentH;
};

exports.getSize = function (props) {
  return {
    width: this.getWidth(props),
    height: this.getHeight(props)
  }
};

exports.getText = function (props) {
  var t = props.currentText || props.text;
  if (props.stateProperties) {
    if (props.stateProperties.hasOwnProperty(propConst.TEXT)) {
      t = props.stateProperties[propConst.TEXT];
    } else if (props.stateProperties.hasOwnProperty(propConst.MULTI_LINE_TEXT)) {
      t = props.stateProperties[propConst.MULTI_LINE_TEXT];
    }
  }
  return t;
};

exports.getBackgroundColor = function (props) {
  var c = props.currentColor || props.color;
  if (props.stateProperties) {
    if (props.stateProperties.color) {
      c = props.stateProperties.color;
    }
  }
  return c;
};

exports.getFontSize = function (props) {
  var s = props.textSize;
  if (props.stateProperties && props.stateProperties.textSize) {
    s = props.stateProperties.textSize;
  }
  return parseInt(s, 10) || 14;
};

exports.getBorderWidth = function (props) {
  return this.getPropertyValue(props, propConst.THICKNESS) || 1;
};

exports.getBorderVisible = function (props) {
  return this.getPropertyValue(props, propConst.BORDER_VISIBLE)
};

exports.parseDashMode = function (v) {
  var value = appTypes.DashMode[v];
  if (value) {
    return value;
  }
  return v;
};

exports.getSelectedColor = function (props) {
  return this.getPropertyValue(props, propConst.SELECTED_COLOR);
};

exports.getRadius = function (props) {
  var radius = 0;
  var w = this.getWidth(props);
  var h = this.getHeight(props);
  var r = this.getPropertyValue(props, 'radius') || this.getPropertyValue(props, 'borderRadius') || 0;
  if (_.isUndefined(props.radiusIsPercent) || props.radiusIsPercent) {
    radius = Math.min(r * 0.005, 0.5) * Math.min(w, h);
  } else {
    radius = Math.min(r, Math.min(w, h) / 2);
  }
  return radius;
};

exports.getBorderColor = function (props) {
  return this.getPropertyValue(props, propConst.BORDER_COLOR);
};

exports.builderTextStyle = function (props, style) {
  if (!props.controlTypeID) { // 说明这不是一个组件
    return style;
  }
  if (!style) {
    style = {};
  }
  style.fontSize = this.getPropertyValue(props, 'textSize');

  if (props.textStyles) {
    style.fontWeight = props.textStyles.fontWeight;
    style.fontStyle = props.textStyles.fontStyle;
    style.textDecoration = props.textStyles.textDecoration;
  } else {
    style.textDecoration = 'inherit';
  }

  // 4.3 版本开始，使用了新的字体策略
  if (versionHelper.isPageVersionLowerThan4_3()) {
    style.fontFamily = props.textFontFamily;
  } else {
    style.fontFamily = dataHelper.decodeURIComponent(props.font.family.replace(/\+/g, '%20'));
    style.fontWeight = props.font.weight;
  }

  style.color = this.getTextColor(props);


  return style;
};

exports.builderBackgroundStyle = function (props, style) {
  if (!style) {
    style = {};
  }
  style.backgroundColor = this.getPropertyValue(props, 'color');// this.getBackgroundColor(props);
  return style;
};

/*
 临时处理的边框样式
 */
var tempBorderMode = {
  solid: appTypes.DashMode.SdSolid,
  dashed: appTypes.DashMode.SdDash,
  dotted: appTypes.DashMode.SdDot,
  'dash-dot': appTypes.DashMode.SdDash,
  'dash-dot-dot': appTypes.DashMode.SdDot
};


exports.builderBorderStyle = function (props, style) {
  var borderVisible = this.getPropertyValue(props, 'borderVisible');
  if (!style) {
    style = {};
  }

  style.borderRadius = this.getRadius(props);
  style.borderWidth = this.getPropertyValue(props, 'thickness') || 1;// props.borderWidth || props.thickness || 1;
  style.borderColor = this.getPropertyValue(props, 'borderColor');

  if (borderVisible) {
    if (props.dashMode) {
      style.borderStyle = tempBorderMode[props.dashMode];
    }
    if (!style.borderStyle) {
      style.borderStyle = 'solid';
    }
    style.boxSizing = 'border-box';
  } else {
    style.borderWidth = 'inherit';
  }

  return style;
};

exports.builderTextAlign = function (props, style) {
  if (!style) {
    style = {};
  }
  if (props.textAlign) {
    style.textAlign = convertHelper.getTextHorizontalAlign(props.textAlign);
  }

  return style;
};

exports.builderBaseStyle = function (props, style) {
  if (!style) {
    style = {};
  }
  style.width = props.currentW || props.w;
  style.height = props.currentH || props.h;
  style.left = 0;
  style.top = 0;
  return style;
};

exports.builderLineHeight = function (props) {
  var style = this.builderTextStyle(props);
  var lineHeight = this.getInt(props, propConst.LINE_SPACING);
  var lineSpacingMultiple = 0;
  var textHeight;
  if (!_.isUndefined(props.lineSpacingMultiple)) {
    lineSpacingMultiple = props.lineSpacingMultiple;
  }
  if (!lineHeight) {
    if (lineSpacingMultiple) {
      textHeight = Math.floor(measureHelper.measureTextWidth(style, 'dp').height);
      if (textHeight < 20) {
        textHeight -= 1;
      }
      lineHeight = Math.round(textHeight * lineSpacingMultiple);
    }
  }
  return lineHeight;
};


/**
 * 样式构建帮助方法
 * 使用方式，styleHelper.StyleUtil(this.props,style).size().background().border().text().align().style;
 * @param props 组件的数据
 * @param style 初始样式，如果该值为空，则需要在构建完成之后，使用style属性获取构建的结果，如果不为空，以始终使用该值
 * @returns {exports.StyleUtil}
 * @constructor
 */
exports.StyleUtil = function (props, style) {
  var self = this;
  var _style = style;

  function clone() {
    var k;
    if (_style) {
      for (k in self.style) {
        _style[k] = self.style[k];
      }
    }
  }

  this.background = function () {
    exports.builderBackgroundStyle(props, self.style);
    clone();
    return self;
  };
  this.border = function () {
    exports.builderBorderStyle(props, self.style);
    clone();
    return self;
  };
  this.text = function () {
    exports.builderTextStyle(props, self.style);
    clone();
    return self;
  };

  this.wrap = function (isWrap) {
    if (_.isUndefined(isWrap)) {
      isWrap = props.textWordWrap;
    }
    if (isWrap) {
      self.style.whiteSpace = 'normal';
      self.style.wordWrap = 'break-word';
    } else {
      self.style.whiteSpace = 'nowrap';
      self.style.wordWrap = 'nowrap'
    }
    clone();
    return self;
  };

  this.align = function () {
    exports.builderTextAlign(props, self.style);
    clone();
    return self;
  };
  this.lineHeight = function (isWrap) {
    var h = props.h;
    var t = props.text;
    if (_.isUndefined(isWrap)) {
      if (!_.isUndefined(props.textWordWrap)) {
        isWrap = false;
      } else {
        isWrap = props.textWordWrap;
      }
    }
    if (isWrap) {
      h = props.textSize * 1.33;
    }
    self.style.lineHeight = h + 'px';
    clone();
    return self;
  };
  this.size = function () {
    self.style.width = props.currentW || props.w;
    self.style.height = props.currentH || props.h;
    clone();
    return self;
  };
  this.point = function () {
    self.style.left = props.currentX || props.x;
    self.style.top = props.currentY || props.y;
    clone();
    return self;
  };

  this.bounds = function () {
    self.point().size();
    return self;
  };

  this.default = function (style) {
    _style = style;
    if (self.style && style) {
      _.extend(self.style, style);
    }
    clone();
    return self;
  };

  this.base = function () {
    if (_.isUndefined(self.style.left))
      self.style.left = 0;
    if (_.isUndefined(self.style.top))
      self.style.top = 0;
    if (_.isUndefined(self.style.width))
      self.style.width = '100%';
    if (_.isUndefined(self.style.height))
      self.style.height = '100%';

    self.style.position = 'absolute';
    self.style.overflow = 'hidden';
    self.style.boxSizing = 'border-box';
    self.style.zIndex = parseInt(props.zOrder, 10);
    clone();
    return self;
  };
  //这里不清理的话，会造成该值永远存在
  delete this.style;

  this.default(style);

  if (!this.style) {
    this.style = {};
  }
  return this;
};


/**
 * 较正字号样式，当字号小于12号时，浏览器会强制限制到12号，此时需要通过对呈现文字的label,p等标签应用缩放样式。
 * 注意，这个较正后的样式只能应用到最终呈现文字的标签上。
 * @param style
 */
exports.adjustTextSizeStyle = function (style) {
  var fontSize = parseInt(style.fontSize, 10);
  var scale;
  if (fontSize < 12) {
    scale = fontSize / 12;
    style.position = 'absolute';
    style.transform = 'scale(' + scale + ')';
    style.WebkitTransformOriginY = 0;
    style.WebkitTransformOriginX = 0;
  }
};

exports.calculeTextSize = function (size, fontSize) {
  var scale = 1;
  if (fontSize < 12) {
    scale = fontSize / 12;
  }
  util.Size.scale(size, scale);
  return scale;
};

exports.shrinkageWordSpacing = function (style) {
  var fontSize = style.fontSize;
  if (fontSize) {
    style.letterSpacing = Math.min(-(fontSize - 14) / 15, 0);
  }
};





// WEBPACK FOOTER //
// ./src/helper/styleHelper.js